import { accessibilityStyle } from './accessibilityStyleCompNode'
import { AccessibilityCssFeature } from './accessibilityStyle.types'
import { accessibilityDomApplier } from './accessibilityStyleDomApplier'

export const accessibilityCssFeature: AccessibilityCssFeature = {
	experimentName: 'specs.thunderbolt.catharsis_accessibility',
	renderableNodes: { accessibilityStyle },
	intermediateNodes: {},
	dataMaps: ['document_data'],
	domApplier: accessibilityDomApplier,
}
